import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  MassOsGenerationForm,
  MassOsGenerationMode,
  MassOsProviderOption,
  buildMassOsPeriodLabel
} from 'src/entities/file';

@Component({
  selector: 'app-mass-os-review-summary',
  templateUrl: './mass-os-review-summary.component.html',
  styleUrls: ['./mass-os-review-summary.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MassOsReviewSummaryComponent {
  @Input() mode: MassOsGenerationMode = 'os';
  @Input() form: MassOsGenerationForm | null = null;
  @Input() providers: MassOsProviderOption[] = [];
  @Input() selectedServiceCount = 0;
  /** Cantidad de tickets seleccionados (crear OS por ticket). */
  @Input() selectedTicketCount = 0;

  @Output() back = new EventEmitter<void>();
  @Output() syncPaymentDate = new EventEmitter<void>();

  get periodLabel(): string {
    return this.form ? buildMassOsPeriodLabel(this.form) : '';
  }

  /** Etiqueta de periodo sin el prefijo "Files " para mostrarla en el chip. */
  get periodText(): string {
    return this.periodLabel.replace(/^Files\s+/i, '');
  }

  get generateLabel(): string {
    return this.mode === 'np'
      ? 'Generar Notas de Pedido'
      : 'Generar Órdenes de Servicio';
  }

  get selectedProvider(): MassOsProviderOption | undefined {
    return this.providers.find(
      (provider) => provider.id === this.form?.providerId
    );
  }
}
